function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\uF362");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Calendar---Events-Calendar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "8.-Large-Components/8.5-Calendar-Card-Copy-18",
  transform: "translate(-16.000000, -80.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "4.-Icons/Extra-Small/Solid/Gray",
  transform: "translate(12.000000, 76.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "4.-Icons/Calendar/12px/Dark",
  transform: "translate(-0.500000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.9602271,9.52273864 L16.8352226,7.64774311 C17.05488,7.42808574 17.05488,7.07194645 16.8352226,6.85226619 L14.9602271,4.97727066 C14.6069946,4.62403816 13.9999785,4.8742283 13.9999785,5.37502056 L13.9999785,6.50001788 L5.56249866,6.50001788 C5.25183808,6.50001788 5,6.75185597 5,7.06251654 L5,7.43751565 C5,7.74817622 5.25183808,8.00001431 5.56249866,8.00001431 L13.9999785,8.00001431 L13.9999785,9.12501162 C13.9999785,9.62788671 14.6083221,9.87459785 14.9602271,9.52273864 Z M7.99999285,13.6250009 L7.99999285,12.5000036 L16.4374727,12.5000036 C16.7481333,12.5000036 16.9999714,12.2481655 16.9999714,11.9375049 L16.9999714,11.5625058 C16.9999714,11.2518452 16.7481333,11.0000072 16.4374727,11.0000072 L7.99999285,11.0000072 L7.99999285,9.87500983 C7.99999285,9.37545353 7.39384653,9.1231348 7.03974428,9.47725993 L5.16474875,11.3522555 C4.94509138,11.5719357 4.94509138,11.928075 5.16474875,12.1477324 L7.03974428,14.0227279 C7.39194681,14.3749304 7.99999285,14.1274182 7.99999285,13.6250009 Z",
  id: "\\uF362"
})))));

var SvgSwitchOutIconSelected = function SvgSwitchOutIconSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "11px",
    viewBox: "0 0 13 11",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSwitchOutIconSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SwitchOutIconSelected.efa41621.svg";
export { ForwardRef as ReactComponent };